var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBorderSpaghettiYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 362,
    height: 684,
    viewBox: "0 0 362 684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 680L31.1049 647.544C31.1049 647.544 98.8622 560.001 162.491 541.083C162.491 541.083 232.903 514.395 301.378 543.017C301.378 543.017 333.587 556.055 330.191 587.768C327.042 617.188 297.853 621.053 297.853 621.053C297.853 621.053 233.549 635.841 184.455 582.854C135.36 529.866 169.405 446.324 169.405 446.324C169.405 446.324 183.226 390.566 245.721 329.099C308.216 267.633 316.044 216.375 317.079 196.471C318.114 176.568 322.254 100.347 261.19 53.2519C200.125 6.15649 127.233 24.127 127.233 24.127C127.233 24.127 40.7379 35.9013 22.6255 151.161C4.51301 266.421 62.9902 367.429 62.9902 367.429C62.9902 367.429 104.906 453.529 188.224 482.981C271.539 512.433 305.694 446.747 305.694 446.747C305.694 446.747 344.691 384.159 322.605 292.447C300.52 200.735 220.85 191.44 220.85 191.44C220.85 191.44 168.041 179.474 108.529 226.046C49.0176 272.617 25.5574 346.979 25.5574 346.979C25.5574 346.979 -1.97349 424.405 14.2074 482.981C30.3875 541.557 58.3327 544.036 58.3327 544.036C58.3327 544.036 97.3675 559.528 117.438 479.59C137.509 399.651 124.572 310.928 124.572 310.928C124.572 310.928 106.256 154.513 169.304 77.9621C232.353 1.41049 341.058 2.10016 361 4.85898",
    stroke: "#FFDF03",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 679.106H0",
    stroke: "#FFDF03",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 655.746V683",
    stroke: "#FFDF03",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderSpaghettiYellow);
export default __webpack_public_path__ + "static/media/border-spaghetti-yellow.86458ae0186232187b928446617617d2.svg";
export { ForwardRef as ReactComponent };